(function () {
  'use strict';

  function closeAllDropdowns(except) {
    document.querySelectorAll('[data-shop-dropdown], [data-watch-toggle], [data-dropdown]').forEach((el) => {
      if (el === except || el.contains(except)) return;
      el.classList.remove('is-open');
      const btn = el.querySelector('button[aria-expanded]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      el.querySelector('[data-shop-menu]')?.setAttribute('hidden', '');
      el.querySelector('[data-watch-menu]')?.setAttribute('hidden', '');
    });
  }

  /* Mobile menu */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const menuCloseEls = document.querySelectorAll('[data-menu-close]');

  function openMenu() {
    mobileDrawer?.classList.add('is-open');
    mobileDrawer?.setAttribute('aria-hidden', 'false');
    menuToggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileDrawer?.classList.remove('is-open');
    mobileDrawer?.setAttribute('aria-hidden', 'true');
    menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  menuToggle?.addEventListener('click', () => {
    mobileDrawer?.classList.contains('is-open') ? closeMenu() : openMenu();
  });
  menuCloseEls.forEach((el) => el.addEventListener('click', closeMenu));

  /* Shop mega menu */
  const shopDropdown = document.querySelector('[data-shop-dropdown]');
  const shopToggle = document.querySelector('[data-shop-toggle]');
  const shopMenu = document.querySelector('[data-shop-menu]');

  shopToggle?.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = shopDropdown?.classList.toggle('is-open');
    shopToggle.setAttribute('aria-expanded', isOpen);
    if (isOpen) {
      shopMenu?.removeAttribute('hidden');
      closeAllDropdowns(shopDropdown);
      shopDropdown?.classList.add('is-open');
    } else {
      shopMenu?.setAttribute('hidden', '');
    }
  });

  /* Watch dropdown */
  const watchBtn = document.querySelector('[data-watch-toggle]');
  const watchMenu = document.querySelector('[data-watch-menu]');
  const watchCell = watchBtn?.closest('.menuIconTwo');

  watchBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = watchCell?.classList.toggle('is-open');
    watchBtn.setAttribute('aria-expanded', isOpen);
    if (isOpen) {
      watchMenu?.removeAttribute('hidden');
      closeAllDropdowns(watchCell);
      watchCell?.classList.add('is-open');
    } else {
      watchMenu?.setAttribute('hidden', '');
    }
  });

  /* Deals dropdown */
  document.querySelectorAll('[data-dropdown]').forEach((dealsDropdown) => {
    const dealsBtn = dealsDropdown.querySelector('.header__deals-btn');
    dealsBtn?.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dealsDropdown.classList.toggle('is-open');
      dealsBtn.setAttribute('aria-expanded', isOpen);
      if (isOpen) closeAllDropdowns(dealsDropdown);
    });
  });

  document.addEventListener('click', () => closeAllDropdowns(null));

  /* Cart drawer */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartCloseEls = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggles.forEach((el) => {
    el.addEventListener('click', (e) => {
      if (cartDrawer) {
        e.preventDefault();
        openCart();
      }
    });
  });
  cartCloseEls.forEach((el) => el.addEventListener('click', closeCart));

  /* Product carousel */
  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const list = carousel.querySelector('.carouselList, .product-carousel__list');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track || !list) return;

    let offset = 0;

    function getStep() {
      const item = list.querySelector('.carouselItem, .product-carousel__item');
      return item ? item.offsetWidth + 12 : 200;
    }

    function updateArrows() {
      const maxOffset = Math.max(0, list.scrollWidth - track.offsetWidth);
      if (prev) prev.disabled = offset <= 0;
      if (next) next.disabled = offset >= maxOffset - 1;
    }

    prev?.addEventListener('click', () => {
      offset = Math.max(0, offset - getStep() * 2);
      list.style.transform = `translateX(-${offset}px)`;
      updateArrows();
    });

    next?.addEventListener('click', () => {
      const maxOffset = Math.max(0, list.scrollWidth - track.offsetWidth);
      offset = Math.min(maxOffset, offset + getStep() * 2);
      list.style.transform = `translateX(-${offset}px)`;
      updateArrows();
    });

    updateArrows();
    window.addEventListener('resize', () => { offset = 0; list.style.transform = ''; updateArrows(); });
  });

  /* Deals gallery expand */
  document.querySelectorAll('[data-deals-gallery]').forEach((gallery) => {
    const list = gallery.querySelector('[data-gallery-list]');
    const toggle = gallery.querySelector('[data-gallery-toggle]');
    toggle?.addEventListener('click', () => {
      const expanded = list?.classList.toggle('is-expanded');
      toggle.textContent = expanded ? 'Show Fewer Deals' : 'Show More Deals';
    });
  });

  /* TSV Countdown */
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const endStr = el.dataset.end;
    let endTime;

    if (endStr) {
      endTime = new Date(endStr.replace(' ', 'T')).getTime();
    } else {
      const now = new Date();
      endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
    }

    const hoursEl = el.querySelector('[data-hours]');
    const minutesEl = el.querySelector('[data-minutes]');
    const secondsEl = el.querySelector('[data-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      const diff = Math.max(0, endTime - Date.now());
      if (hoursEl) hoursEl.textContent = pad(Math.floor(diff / 3600000));
      if (minutesEl) minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (secondsEl) secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    setInterval(tick, 1000);
  });

  /* Product thumbnails */
  document.querySelectorAll('.main-product__thumbnail').forEach((btn) => {
    btn.addEventListener('click', () => {
      const img = btn.querySelector('img');
      const featured = document.getElementById('ProductFeaturedImage');
      if (img && featured) {
        featured.src = img.src.replace(/width=\d+/, 'width=1200');
        featured.alt = img.alt;
      }
      btn.closest('.main-product__thumbnails')?.querySelectorAll('.main-product__thumbnail').forEach((t) => t.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  /* Sticky header shadow */
  const header = document.querySelector('[data-header]');
  if (header?.classList.contains('header--sticky')) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 8px rgba(0,0,0,0.08)' : '';
    }, { passive: true });
  }
})();
